module.exports = __webpack_public_path__ + "static/59gde-878be96f1a7a33e5f964534771d34d70.gif";